import {Button, Flex} from "antd";
import React from "react";
import Result from "antd/lib/result";
import {useNavigate} from "react-router";

interface IStage {
    name: string,
    state: boolean
}

export default function Step15() {

    const navigate = useNavigate();

    return (
        <Flex vertical justify={"center"} align={"center"} gap={20}>
            <Result
                status="success"
                title="Заявление успешно отправлено"
                subTitle="Вы можете подать еще одно заявление на другую основу обучения"
                extra={[
                    <Button type="primary" key="console" onClick={() => {
                        navigate("/admission");
                    }}>
                        К списку заявлений
                    </Button>,
                ]}
            />
        </Flex>
    )
}